module.exports = __webpack_public_path__ + "img/qoala-think.21b5a54.gif";